"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoundedBox = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _core = require("./core");

var BoundedBox = function BoundedBox(_ref) {
  var _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 'xlarge' : _ref$maxWidth,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["maxWidth", "children"]);
  return _react.default.createElement(_core.Box, (0, _extends2.default)({
    pl: [2, 4],
    pr: [2, 4],
    pb: [4, 6],
    pt: [4, 6]
  }, props), _react.default.createElement(_core.Box, {
    maxWidth: maxWidth,
    mx: "auto",
    height: "100%"
  }, children));
};

exports.BoundedBox = BoundedBox;